import React from "react";
import { Box, Flex, Input, Select, Text } from "@chakra-ui/react";
import { FaPlus, FaTimes } from "react-icons/fa";
import { FORUM, TRANSITION } from "../Theme/styles";
import { CATEGORIES, findCategory } from "../categories";
import { isRcon } from "../permissions";

const ItemList = ({ assignment, people, highlight, onChange, onDeadlineChange, onTeamChange }) => {
  const items = assignment.items && assignment.items.length > 0
    ? assignment.items
    : [{ description: "" }];

  const person =
    assignment.kind === "person"
      ? people.find((o) => o.id === assignment.assigned_to)
      : null;
  const header = findCategory(assignment.team)?.name || assignment.team;
  const empty = items.filter((p) => p.description.trim()).length === 0;

  const setAt = (indeks, wartosc) =>
    onChange(items.map((p, i) => (i === indeks ? { description: wartosc } : p)));

  const add = () => onChange([...items, { description: "" }]);

  const remove = (indeks) => {
    const zostaje = items.filter((_, i) => i !== indeks);
    onChange(zostaje.length > 0 ? zostaje : [{ description: "" }]);
  };

  return (
    <Box
      border={"1px solid"}
      borderColor={highlight && empty ? "#E06C6C" : FORUM.obramowanie}
      bg={FORUM.tlo}
      borderRadius={"md"}
      px={3}
      py={2.5}
      mb={2}
      transition={TRANSITION}
    >
      <Flex align={"center"} gap={2} mb={2}>
        {assignment.kind === "person" && onTeamChange ? (
          <Select
            size={"xs"}
            maxW={"180px"}
            value={assignment.team}
            onChange={(e) => onTeamChange(e.target.value)}
            title={"Kategoria tej części"}
          >
            {CATEGORIES.filter((c) => !c.rconOnly || isRcon()).map((c) => (
              <option key={c.key} value={c.key}>
                {c.name}
              </option>
            ))}
          </Select>
        ) : (
          <Text fontSize={"sm"} fontWeight={"600"} color={FORUM.tekstJasny}>
            {header}
          </Text>
        )}
        {person && (
          <Text fontSize={"xs"} color={"#6C99FF"}>
            {person.nickname}
          </Text>
        )}
        {!person && (
          <Text fontSize={"10px"} color={FORUM.tekstPrzygaszony}>
            cały zespół
          </Text>
        )}
        <Box flex={1} />
        <Input
          size={"xs"}
          type={"date"}
          maxW={"140px"}
          value={assignment.deadline || ""}
          onChange={(e) => onDeadlineChange(e.target.value || null)}
          title={"Termin tej części (opcjonalny)"}
        />
      </Flex>

      <Flex direction={"column"} gap={1.5}>
        {items.map((item, i) => (
          <Flex key={i} gap={2} align={"center"}>
            <Input
              size={"sm"}
              placeholder={i === 0 ? "Co ma zrobić" : "Kolejna rzecz"}
              value={item.description}
              onChange={(e) => setAt(i, e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  add();
                }
              }}
            />
            {items.length > 1 && (
              <Box
                as={"button"}
                type={"button"}
                onClick={() => remove(i)}
                color={FORUM.tekstPrzygaszony}
                transition={TRANSITION}
                _hover={{ color: "#E06C6C" }}
                title={"Usuń"}
              >
                <FaTimes size={12} />
              </Box>
            )}
          </Flex>
        ))}
      </Flex>

      <Flex
        as={"button"}
        type={"button"}
        align={"center"}
        gap={1.5}
        mt={2}
        color={FORUM.tekstPrzygaszony}
        transition={TRANSITION}
        _hover={{ color: FORUM.tekstJasny }}
        onClick={add}
      >
        <FaPlus size={9} />
        <Text fontSize={"xs"}>Dodaj kolejną</Text>
      </Flex>
    </Box>
  );
};

export default ItemList;
